'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Method to check if something is function or not
 * @param {string} entity
 * @return {boolean}
 */
var isFunction = exports.isFunction = function isFunction(entity) {
  return typeof entity === 'function';
};

/**
 * Method to check if something is emitter or not
 * @param {string} emitter
 * @return {boolean}
 */
var isEmitter = exports.isEmitter = function isEmitter(emitter) {
  return emitter && isFunction(emitter.on) && isFunction(emitter.off);
};